export default function (value, precision = 0) {
	return Number.parseFloat(value).toFixed(precision)
}
